import React, { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { GameSection, GameStructure, loadingStore, useSoundWatcher } from '@pascal/pascal-core';

import { betStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { totalBetStore } from '../store/totalBetStore';
import { liveBetsDataStore } from '../store/liveBetsDataStore';
import gameLogo from '../assets/images/baccarat/bacarat-logo.png';

import FooterWr from './footer';
import { HeaderWr } from './header';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';
import { WebGameMain } from '../game';
import { gameService } from '../services';

export const WebGame = observer(({ isReplay }) => {
  // const { roomName } = lobbyStore;
  const { isSkipLobby } = gameConfigStore;
  const { repliedBetData } = betStore;
  useSoundWatcher();

  useEffect(() => {
    return () => {
      totalBetStore.setTotalBet(0);
      liveBetsDataStore.resetLiveBetsData([]);
      loadingStore.updateLoading({ isGameInitialLoaded: false });
    };
  }, []);

  useEffect(() => {
    if (isReplay && repliedBetData) {
      gameService.handleReplay(repliedBetData);
    }
  }, [isReplay, repliedBetData]);

  return (
    <GameStructure
      hasGameTypeLoading={isSkipLobby}
      hasLobby={isSkipLobby}
      lobbyLogoImageSrc={gameLogo}
    >
      {!isReplay && <HeaderWr />}
      <GameSection haveNotification translationValues={{}}>
        {!isReplay ? <PayoutsAndResultsContainer /> : null}
        <WebGameMain isReplay={isReplay} />
      </GameSection>
      {!isReplay && <FooterWr />}
    </GameStructure>
  );
});
